export const constructFaviconUrl = (url: string): string => {
  try {
    const urlWithProtocol = url.replace(/((^\w+:|^)\/\/)|^/, 'https://');
    const faviconURL = new URL(urlWithProtocol);

    return `${faviconURL.origin}/favicon.ico`;
  } catch {
    return '';
  }
};
